export default __webpack_public_path__ + "images/9bfe904b6e152b52cc4b88a1a05a75cf.png";